export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "https://baelleaves.com/backend";
export const API_BASE_URL = `${BACKEND_URL}/api.php`;

export async function fetchAPI(endpoint: string, init?: RequestInit) {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, init);
    return response.json();
  } catch (error) {
    console.error("Fetch failed:", error);
    throw error;
  }
}

export async function getSettings() {
  return fetchAPI("?type=settings");
}
